import * as React from 'react';

import SpookyMaticLogo from './SpookyMaticLogo';
import useSpookyMode from './useSpookyMode';

const withSpookyLogo = (Logo: React.ComponentType<React.SVGProps<SVGSVGElement>>) => {
  const LogoOrSpookyLogo = (props: React.SVGProps<SVGSVGElement>) => {
    const spooky = useSpookyMode();

    return spooky ? <SpookyMaticLogo {...props} /> : <Logo {...props} />;
  };

  return LogoOrSpookyLogo;
};

export default withSpookyLogo;
